import React, { useState } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { authSignin } from "src/redux/actions";
import { apiResetPassword, setAuthToken } from "src/api";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { apiSignIn } from "src/api";
import { Copyright } from "../copyright";
import { useNavigate } from "react-router-dom";
import {
  ReportProblem as ReportProblemIcon,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import {
  CssBaseline,
  Grid,
  Container,
  Box,
  Hidden,
  Button,
  TextField,
  Checkbox,
  CircularProgress,
  makeStyles,
  Typography,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputAdornment,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  OutlinedInput,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { useSnackbar } from "notistack";
import { LanguageSelect } from "src/layouts/DashboardLayout/languageSelect";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundImage: "url('/signinMainBg.png')",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  paper: {
    backgroundImage: "url('/signinBg.png')",
    backgroundPosition: "center",
    backgroundClip: "content-box",
    backgroundAttachment: "fixed",
    backgroundColor: theme.palette.background.default,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "1.5em",
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 3px rgba(0,0,0,0.24)",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  errorBox: {
    display: "flex",
    padding: "13px 22px",
    border: "1px solid lightcoral",
    background: "lightpink",
    borderRadius: "8px",
    color: "#414141",
  },
  form: {
    minWidth: "250px", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  signinForm: {
    background: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(4),
  },
  buttonProgress: {
    color: theme.palette.success.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  buttonSuccess: {
    backgroundColor: theme.palette.success.main,
  },
  poster: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    borderTopRightRadius: "1.5em",
    borderBottomRightRadius: "1.5em",
    overflow: "hidden",
    color: "white",
    boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.3)",

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: 'url("/exomeLogoBg.svg")',
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      opacity: 0.15,
      zIndex: 0,
    },

    zIndex: 1,
  },

  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  inputLabel: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
}));

const ForgotPassword = (props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleClickOpen = (event) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setLoading(false);
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const formElements = event.target.elements;

    setLoading(true);

    apiResetPassword(
      { action: "generate-token", email: formElements["email"].value },
      (data, status) => {
        setLoading(false);
        if (status === 201) {
          enqueueSnackbar("Password reset link was sent to your email.", {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Something went wrong. Please try again later.", {
            variant: "error",
          });
        }
        handleClose();
      }
    );
  };

  return (
    <div style={{ marginLeft: "auto" }}>
      <Link href="#" onClick={handleClickOpen}>
        {t("Forget password")}
      </Link>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{t("Reset password")}</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>
              {t("Please enter your email to receive the reset password link.")}
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              name="email"
              label={t("Email")}
              required
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} onClick={handleClose} color="primary">
              {t("Cancel")}
            </Button>
            <Button
              disabled={loading}
              type="submit"
              variant="contained"
              color="primary"
            >
              {t("Send")}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authToken: state.authToken || localStorage.getItem("mbiAuth"),
  };
};

function mapDispatchToProps(dispatch) {
  return {
    authSignin: (data) => dispatch(authSignin(data)),
  };
}

const ConnectedSignInPage = (props) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const errorMessages = {
    // "Request failed with status code 400": t(
    //   "Username and password did not match!"
    // ),
    400: t("Username and password did not match!"),
  };

  const signInCallback = (data, status) => {
    if (status === 200) {
      setSuccess(true);
      props.authSignin(data.token);
      setAuthToken(data.token, () => {
        navigate("/dashboard"); // TODO or the reference page});
      });
    } else {
      // setErrorMessage(errorMessages[data.message]);
      setErrorMessage(errorMessages[status]);
      setLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      username: event.target[0].value,
      password: event.target[2].value,
    };
    setLoading(true);
    sessionStorage.setItem("organizationName", data.username);
    if (data.username === "system") {
      setErrorMessage(errorMessages[400]);
      setLoading(false);
    } else {
      apiSignIn(data, signInCallback);
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <main>
      <Box position={"absolute"} top={0} right={0} p={2}>
        <LanguageSelect />
      </Box>
      <Box
        alignItems="center"
        justifyContent="center"
        className={classes.mainContainer}
      >
        <Container>
          <CssBaseline />
          <Grid container className={classes.paper}>
            <Grid item xs={12} md={6} className={classes.signinForm}>
              <Trans>
                <img
                  src="/exomeLogoTopBar.svg"
                  alt="logo"
                  style={{ height: "180px", paddingBottom: "20px" }}
                />
                <Typography
                  component="h1"
                  variant="h4"
                  align="center"
                  style={{
                    marginBottom: "3px",
                    fontWeight: 400,
                    color: "primary.main",
                    letterSpacing: "0.5px",
                  }}
                >
                  {t("Sign in to your account")}
                </Typography>
              </Trans>
              {errorMessage && (
                <Box className={classes.errorBox}>
                  <ReportProblemIcon style={{ marginRight: "8px" }} />
                  <Typography>{errorMessage}</Typography>
                </Box>
              )}
              <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label={t("Email Address")}
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                <FormControl style={{ width: "100%" }} variant="outlined">
                  <InputLabel
                    htmlFor="standard-adornment-password"
                    className={classes.inputLabel}
                    required
                  >
                    {t("Password")}
                  </InputLabel>
                  <OutlinedInput
                    margin="normal"
                    style={{ width: "100%" }}
                    required
                    fullWidth
                    name="password"
                    type={showPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    id="password"
                    autoComplete="current-password"
                  />
                </FormControl>
                <Box display="flex" alignItems="center">
                  <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label={t("Remember me")}
                  />
                  <ForgotPassword />
                </Box>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={clsx(classes.submit, {
                    [classes.buttonSuccess]: success,
                  })}
                  disabled={loading}
                >
                  {t("Sign in")}
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </form>
            </Grid>
            <Hidden smDown>
              <Grid
                id="sign_in"
                item
                xs={12}
                md={6}
                className={clsx(classes.poster)}
              >
                <Typography
                  component="h1"
                  variant="h3"
                  align="center"
                  style={{
                    marginBottom: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Massive Analyser
                </Typography>
                <Typography
                  component="h1"
                  variant="h5"
                  align="center"
                  style={{
                    marginBottom: "30px",
                    fontStyle: "italic",
                  }}
                >
                  {t("Upload & Analyze. All you need is a browser!")}
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: "white !important",
                    textAlign: "justify",
                    fontSize: "15px",
                    paddingRight: "16px",
                    paddingLeft: "16px",
                  }}
                >
                  {t("app_intro")}
                </Typography>
              </Grid>
            </Hidden>
          </Grid>
          <Box mt={8}>
            <Copyright />
          </Box>
        </Container>
      </Box>
    </main>
  );
};

export const SignInPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedSignInPage);
